<template>
  <div class="purchaseContainer">
    <div class="purchase w" v-if="shopList.length">
      <div class="title">采购清单</div>
      <div class="table">
        <el-table
          :data="shopList"
          size="mini"
          stripe
          height="410"
          style="width: 100%"
        >
          <el-table-column label="品牌" width="50">
            <template slot-scope="scope">
              <img :src="scope.row.imgurlpinpai" alt="" />
            </template>
          </el-table-column>
          <el-table-column label="图片" width="50">
            <template slot-scope="scope">
              <img :src="scope.row.imgurl" alt="" />
            </template>
          </el-table-column>
          <el-table-column label="名称" width="140" style="text-align: center">
            <template slot-scope="scope">
              <span>
                {{ scope.row.pfullname }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="材质" width="120">
            <template slot-scope="scope">
              <span>
                {{ scope.row.caizhi }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="标准" width="70">
            <template slot-scope="scope">
              <span>
                {{ scope.row.standerd }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="型号" width="140">
            <template slot-scope="scope">
              <span>
                {{ scope.row.xinghao }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="颜色" width="70">
            <template slot-scope="scope">
              <span>
                {{ scope.row.color }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="单位" width="70">
            <template slot-scope="scope">
              <span>
                {{ scope.row.unitname }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="单价" width="70">
            <template slot-scope="scope">
              <span>
                {{ parseFloat(scope.row.price).toFixed(2) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="数量" width="130">
            <template slot-scope="scope">
              <my-input
                v-model="scope.row.qty"
                :max="99999"
                :min="1"
                @on-change="numChange"
              ></my-input>
            </template>
          </el-table-column>
          <el-table-column label="金额">
            <template slot-scope="scope">
              ￥{{ parseFloat(scope.row.qty * scope.row.price).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="重量">
            <template slot-scope="scope">
              {{ parseFloat(scope.row.qty * scope.row.mweight).toFixed(2) }}g
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <i
                class="el-icon-delete"
                @click="deleteRow(scope.row.ptypeid)"
              ></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="tablePice clearfix">
        <div class="pice">
          <div>合计:</div>
          <div class="red">￥{{ parseFloat(num).toFixed(2) }}</div>
          <div class="red">{{ (parseFloat(weight) / 1000).toFixed(2) }}kg</div>
        </div>
      </div>

      <div class="selectContainer">
        <div class="select">
          <div class="selectItem">
            <div class="name">开票选择:</div>
            <div class="rightSelect">
              <el-radio-group v-model="radio" @change="radioChange">
                <el-radio label="无需开票">无需开票</el-radio>
                <el-radio label="电子普通发票">电子普通发票</el-radio>
                <el-radio label="增值税专用发票">增值税专用发票</el-radio>
              </el-radio-group>
            </div>
            <div style="font-size: 14px">（13%税率）</div>
          </div>
          <div class="selectItem">
            <div class="name">运输方式:</div>
            <div class="rightSelect">
              <el-select
                v-model="transportValue"
                placeholder="默认物流到付"
                popper-class="purchaseSelect"
                @focus="transportFocusChange"
                @change="computkdmoneyChange"
              >
                <el-option
                  v-for="item in logisticsList"
                  :key="item.label"
                  :label="item.label"
                  :value="item.label"
                >
                </el-option>
              </el-select>
            </div>
            <div class="l-ti">
              (10公斤以下，1米以下可以选择快递，超过请选择物流)
            </div>
          </div>
          <div class="selectItem p-20">
            <div class="name">收货地址:</div>
            <div class="rightSelect site">
              <div>
                <div class="inputItem">
                  <el-input v-model="consignee" placeholder="收货人"></el-input>
                </div>
                <div class="inputItem">
                  <el-input v-model="phone" placeholder="手机号"></el-input>
                </div>
                <div class="inputItem">
                  <el-cascader
                    :options="cityData"
                    v-model="city"
                    @change="computkdmoneyChange"
                  ></el-cascader>
                </div>
                <div class="inputItem">
                  <el-input
                    v-model="detaAddress"
                    placeholder="详细地址"
                  ></el-input>
                </div>
              </div>
            </div>
            <div class="l-site" @click="temporarySite" ref="Msite">
              采用默认地址
            </div>
          </div>
          <div class="selectItem p-20">
            <div class="name">
              备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注:
            </div>
            <div class="inputItem" style="width: 630px">
              <el-input v-model="bmark" placeholder="备注"></el-input>
            </div>
          </div>
          <div class="s_title">
            如需代发，请备注清楚收货人联系方式地址信息，并确定运输方式，一旦发出不做更改。
          </div>
          <div class="priceInfo clearfix">
            <div class="box">
              <div class="item">
                <div class="i_name">商品合计:</div>
                <div class="i_price">￥{{ parseFloat(num).toFixed(2) }}</div>
              </div>
              <div class="item">
                <div class="i_name">税费:</div>
                <div class="i_price">￥{{ parseFloat(taxes).toFixed(2) }}</div>
              </div>
              <div class="item i_b">
                <div class="i_name">邮费:</div>
                <div class="i_price">￥{{ parseInt(transportation) }}</div>
              </div>
            </div>
          </div>
          <div class="piceitem">
            <span
              >金额大写：
              <span class="c-s">
                {{
                  this.$money.changeNumMoneyToChinese(
                    parseFloat(num + taxes + parseInt(transportation)).toFixed(
                      2
                    )
                  )
                }}
              </span>
            </span>
            <span
              >&nbsp;&nbsp;合计金额：
              <b
                >￥{{
                  parseFloat(num + taxes + parseInt(transportation)).toFixed(2)
                }}</b
              >
            </span>
          </div>
        </div>
        <div class="s-btn clearfix">
          <div class="jx" @click="$router.push('/product')">继续添加商品>></div>
          <div class="btn" @click="submitOrder">提交订单</div>
        </div>
      </div>
    </div>
    <div v-else>
      <el-empty description="购物车空空如也"></el-empty>
    </div>
    <el-dialog
      title="选择地址"
      :visible.sync="siteDialogVisible"
      width="86%"
      @close="siteDialogCloseChange"
      custom-class="siteDialog"
    >
      <div class="dialogSite">
        <el-table :data="shaddressList" border size="small">
          <el-table-column label="收货人">
            <template slot-scope="scope">
              <span>{{ scope.row.bperson }}</span>
            </template>
          </el-table-column>
          <el-table-column label="所属地区">
            <template slot-scope="scope">
              <span>{{ scope.row.barea }}</span>
            </template></el-table-column
          >
          <el-table-column label="详细地址">
            <template slot-scope="scope">
              <span>{{ scope.row.baddress }}</span>
            </template></el-table-column
          >
          <el-table-column label="联系方式">
            <template slot-scope="scope">
              <span>{{ scope.row.blinktype }}</span>
            </template></el-table-column
          >
          <el-table-column label="默认地址">
            <template slot-scope="scope">
              <input
                type="checkbox"
                v-model="scope.row.isdef"
                class="checkbox"
                @click="selchk"
              /> </template
          ></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="siteDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="siteDialogConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MyInput from "@/components/MyInput";
import cityData from "../../../public/citydata";
import { orderRouter } from "@/router";
import {
  saveorderbill,
  getwuliulist,
  getshaddress,
  computkdmoney,
  getbilldetail,
} from "@/api";
export default {
  components: { MyInput },
  data() {
    return {
      flag: false,
      Msite: "",
      radio: "无需开票",
      city: "",
      siteDialogVisible: false,
      detaAddress: "",
      phone: "",
      consignee: "",
      bmark: "",
      logisticsList: [],
      shaddressList: [],
      transportValue: "物流到付",
      siteValue: "",
      shopList: [],
      num: 0,
      weight: 0,
      // 税费
      taxes: 0,
      // 运费
      transportation: 0,
      cityData,
      showSite: false,
      // 防抖
      timeout: null,
      isflag: false,
    };
  },
  methods: {
    // checkbox只能选中一个
    selchk(event) {
      const checkboxs = document.querySelectorAll(".checkbox");
      checkboxs.forEach((item) => {
        item.checked = false;
      });
      event.target.checked = true;
    },
    siteDialogCloseChange() {
      if (!this.flag) {
        this.$refs.Msite.style = "border:none";
        this.showSite = false;
      }
    },
    siteDialogConfirm() {
      this.shaddressList.forEach((item) => {
        if (item.isdef) {
          this.flag = true;
          this.city = item.barea.split("/");
          this.consignee = item.bperson;
          this.phone = item.blinktype;
          this.detaAddress = item.baddress;
          this.siteDialogVisible = false;
          this.showSite = true;
          this.$refs.Msite.style = "border:1px solid #3285ff";
          this.computkdmoneyChange();
        }
      });
    },
    temporarySite(event) {
      this.showSite = !this.showSite;
      if (this.showSite) {
        this.siteDialogVisible = true;
        this.getshaddressList();
        event.target.style = "border:1px solid #3285ff";
      } else {
        event.target.style = "border:none";
        this.city = "";
        this.detaAddress = "";
        this.phone = "";
        this.consignee = "";
        this.transportation = 0;
      }
    },
    // 提交订单
    async submitOrder() {
      if (!this.$route.query.Number && !this.$store.state.numberOdd) {
        let obj = {};
        let shopList = [];
        this.shopList.forEach((item) => {
          obj = {
            unitname: item.unitname,
            price: item.price,
            qty: item.qty,
            ptypeid: item.ptypeid,
          };
          shopList.push(obj);
        });
        let json = JSON.stringify(shopList);
        const {
          radio,
          transportValue,
          consignee,
          phone,
          city,
          detaAddress,
          bmark,
        } = this;
        let str = "";
        if (city) {
          city.forEach((item, index) => {
            if (index == 0) {
              str += item;
            } else {
              str += "/" + item;
            }
          });
        }
        let sharea = str;
        if (consignee && phone && city && detaAddress) {
          let usercode = window.sessionStorage.getItem("usercode");
          let token = window.sessionStorage.getItem("token");
          const { data: res } = await saveorderbill({
            usercode,
            token,
            billno: "",
            transtype: transportValue,
            shaddress: detaAddress,
            shphone: phone,
            json,
            sharea,
            shperson: consignee,
            taxflag: radio,
            bmark,
          });
          let result = JSON.parse(res)[0];
          if (result.code !== 200) {
            this.$notify.error({
              title: "错误",
              message: result.message,
              duration: 1000,
            });
          } else {
            this.shopList = [];
            this.$store.commit("shopListEmpty");
            this.$store.commit("shopNumReset");
            this.$router.addRoutes(orderRouter);
            const Number = result.message;
            this.$router.push({
              path: "/orderpay",
              query: {
                Number,
              },
            });
          }
        } else {
          this.$notify.error({
            title: "错误",
            message: "收货地址信息不能为空!",
            duration: 2000,
          });
        }
      } else {
        if (this.consignee && this.phone && this.city && this.detaAddress) {
          let json = JSON.stringify(this.shopList);
          let str = "";
          if (this.city) {
            this.city.forEach((item, index) => {
              if (index == 0) {
                str += item;
              } else {
                str += "/" + item;
              }
            });
          }
          let sharea = str;
          let usercode = window.sessionStorage.getItem("usercode");
          let token = window.sessionStorage.getItem("token");
          let billno = this.$route.query.Number
            ? this.$route.query.Number
            : this.$store.state.numberOdd;
          const { data: res } = await saveorderbill({
            usercode,
            token,
            billno,
            transtype: this.transportValue,
            shaddress: this.detaAddress,
            shphone: this.phone,
            json,
            sharea,
            shperson: this.consignee,
            taxflag: this.radio,
            bmark: this.bmark,
          });
          let result = JSON.parse(res)[0];
          if (result.code !== 200) {
            this.$notify.error({
              title: "错误",
              message: result.message,
              duration: 1000,
            });
          } else {
            this.shopList = [];
            this.$store.commit("shopListEmpty");
            this.$store.commit("shopNumReset");
            this.$router.addRoutes(orderRouter);
            const Number = result.message;
            this.$router.push({
              path: "/orderpay",
              query: {
                Number,
              },
            });
          }
        } else {
          this.$notify.error({
            title: "错误",
            message: "收货地址信息不能为空!",
            duration: 2000,
          });
        }
      }
    },
    // radio
    radioChange(label) {
      if (label == "无需开票") {
        this.taxes = 0;
      } else {
        this.taxes = this.num * 0.08;
      }
    },
    // 获取收货地址
    async getshaddressList() {
      let usercode = window.sessionStorage.getItem("usercode");
      let token = window.sessionStorage.getItem("token");
      const { data: res } = await getshaddress({ usercode, token });
      this.shaddressList = JSON.parse(res);
    },
    // 获取物流列表
    async getwuliulists() {
      let usercode = window.sessionStorage.getItem("usercode");
      let token = window.sessionStorage.getItem("token");
      const { data: res } = await getwuliulist({
        usercode,
        token,
      });
      this.logisticsList = JSON.parse(res);
    },
    // 计算快递费用
    async computkdmoneyChange() {
      let usercode = window.sessionStorage.getItem("usercode");
      let token = window.sessionStorage.getItem("token");
      const { city, weight, transportValue } = this;
      let sharea = "";
      let str = "";
      if (city) {
        str = "";
        city.forEach((item, index) => {
          if (index == 0) {
            str += item;
          } else {
            str += "/" + item;
          }
        });
        sharea = str;
      }
      if (city && transportValue) {
        const { data: res } = await computkdmoney({
          usercode,
          token,
          barea: sharea,
          bweight: weight,
          kdname: transportValue,
        });
        const result = JSON.parse(res)[0];
        if (result.code !== 200) {
          this.$notify.error({
            title: "错误",
            message: result.message,
            duration: 1000,
          });
        } else {
          this.transportation = result.mtoken;
        }
      }
    },
    transportFocusChange() {
      this.getwuliulists();
    },
    getShopList() {
      this.shopList = this.$store.state.shopList;
      this.countAll();
    },
    numChange() {
      this.isflag = false;
      this.countAll();
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.computkdmoneyChange();
        this.isflag = true;
      }, 600);
    },
    // 通过订单号获取列表
    async getOrderList(billno) {
      if (billno) {
        let usercode = window.sessionStorage.getItem("usercode");
        let token = window.sessionStorage.getItem("token");
        const { data: res } = await getbilldetail({ usercode, token, billno });
        const result = JSON.parse(res);
        this.shopList = result;
        this.$store.commit("shopListAddArr", result);
        this.countAll();
      } else {
        this.getShopList();
      }
    },
    deleteRow(id) {
      this.$confirm("删除将无法找回，请谨慎操作", "要删除此物品吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$store.commit("shopListRemove", id);
          this.$store.commit("changeShoprowCount",-1)
          this.$notify({
            title: "成功",
            message: "删除成功!",
            type: "success",
            duration: 1000,
          });
          this.getShopList();
        })
        .catch(() => {
          this.$notify.info({
            title: "提示",
            message: "已取消删除",
            duration: 1000,
          });
        });
    },
    // 计算价钱重量
    countAll() {
      this.num = 0;
      this.weight = 0;
      this.taxes = 0;
      this.$store.commit("shopNumReset");
      this.shopList.forEach((ele, i) => {
        this.num += parseFloat(ele.qty) * parseFloat(ele.price);
        this.weight += parseFloat(ele.qty) * parseFloat(ele.mweight);
        this.$store.commit("changeShopNum", parseFloat(ele.qty));
      });
      if (this.radio !== "无需开票") {
        this.taxes = this.num * 0.13;
      } else {
        this.taxes = 0;
      }
    },
  },
  created() {
    this.getShopList();
    this.getOrderList(this.$route.query.Number);
  },
  watch: {},
};
</script>
<style lang='less' scoped>
.purchaseContainer {
  .dialogSite {
    width: 100%;
    .el-select {
      width: 100%;
    }
  }
  .purchase {
    background: #f3f4f6;
    .s-btn {
      line-height: 35px;
      .jx {
        color: #666666;
        float: left;
        cursor: pointer;
      }
      .btn {
        cursor: pointer;
        width: 120px;
        height: 35px;
        text-align: center;
        line-height: 35px;
        float: right;
        color: #fff;
        background: #e4040c;
      }
    }
    .table {
      img {
        width: 35px;
      }
    }
    .selectContainer {
      padding: 30px;
      .piceitem {
        padding: 20px 0;
        text-align: right;
        span {
          color: #6e6e6e;
        }
        .c-s {
          color: #000;
        }
        b {
          padding-left: 25px;
          font-size: 20px;
          color: #e5040b;
          font-weight: 600;
        }
      }
      .select {
        .priceInfo {
          .box {
            float: right;
          }
          .i_b {
            border-bottom: 1px solid #cccccc;
            padding-bottom: 15px;
          }
          .item {
            display: flex;
            height: 25px;
            line-height: 25px;
            .i_name {
              width: 80px;
              color: #666666;
              text-align: end;
              margin-right: 20px;
            }
          }
        }
        .p-20 {
          padding-bottom: 10px !important;
        }
        .s_title {
          margin-left: 100px;
        }
        .selectItem {
          line-height: 28px;
          .Selectsite {
            width: 600px;
          }
          .l-ti {
            color: #323232;
            margin-top: 2px;
            margin-left: 5px;
          }
          .rightSelect {
            position: relative;
            .inputItem {
              width: 350px;
              margin-bottom: 20px;
            }
          }
          .l-site {
            cursor: pointer;
            background: #fff;
            border-radius: 5px;
            width: 118px;
            text-align: center;
            margin-left: 10px;
            height: 28px;
            line-height: 28px;
          }
          display: flex;
          padding-bottom: 40px;
          .name {
            width: 100px;
          }
        }
      }
    }
    .title {
      padding: 40px 0 20px 0;
      text-align: center;
      color: #000;
      font-size: 16px;
      font-weight: 500;
    }
    .tablePice {
      background: #eaeaea;
      .pice {
        float: right;
        display: flex;
        height: 40px;
        line-height: 40px;
        padding-right: 40px;
        .red {
          font-size: 16px;
          color: #d21c19;
        }
        div {
          margin: 0 20px;
          text-align: left;
        }
      }
    }
  }
}
</style>